module.exports = __webpack_public_path__ + "img/open-region-login.50c7cb6f.svg";